import { Instance, types } from 'mobx-state-tree';
import { AdminCorrectAnswer } from './admin-correct-answer.store';

export const AdminBlankCorrectAnswer = AdminCorrectAnswer.named('AdminBlankCorrectAnswer').props({
  blankId: types.string,
});

export interface AdminBlankCorrectAnswerInstance extends Instance<typeof AdminBlankCorrectAnswer> {}
